import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../auth/services/auth.service';
import { UserService } from '../services/user.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService:AuthService = inject(AuthService);
  const router:Router = inject(Router);
  const isValidUser = authService.verifyUserLogin();
  if(isValidUser){
    return true;
  } router.navigateByUrl("/auth/login");
    return false;
};

export const subscriptionGuard: CanActivateFn = async (route, state) => {
  const userService = inject(UserService);
  const hasValidSubscription = userService.hasActiveSubscription();
  if(hasValidSubscription){
    return true;
  }
    return false;
};
